'use client'
import type { ReactNode, ButtonHTMLAttributes, InputHTMLAttributes,
  SelectHTMLAttributes, TextareaHTMLAttributes } from 'react'
import { createContext, useContext, useEffect, useId, useRef, useState } from 'react'
import { cx } from '../utils'

export function Input({
  className,
  ...rest
}: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...rest} className={cx('pxs-focus h-10 w-full rounded-xs border border-line-strong bg-surface px-3 text-[15px] text-ink shadow-[var(--shadow-xs)] transition-colors duration-100 placeholder:text-ink-3 hover:border-accent focus:border-accent focus:shadow-[0_0_0_3px_var(--color-accent-soft)] disabled:bg-sunken disabled:text-ink-3 disabled:shadow-none', className)} />
}
